import React from 'react';
import PageTemplate from '../components/PageTemplate';

const ColorSwatches = () => {
  const colors = [
    {
      name: 'Primary Black',
      variable: '--primary-black',
      value: '#000000',
      description: 'Main text and primary elements'
    },
    {
      name: 'Secondary Light',
      variable: '--secondary-light',
      value: '#f8f9fa',
      description: 'Light backgrounds and sections'
    },
    {
      name: 'Text Black',
      variable: '--text-black',
      value: '#000000',
      description: 'Primary text color'
    },
    {
      name: 'Accent Blue',
      variable: '--accent-blue',
      value: '#0068A6',
      description: 'Primary brand color, buttons, links'
    },
    {
      name: 'Accent Red',
      variable: '--accent2-red',
      value: '#AB1636',
      description: 'Secondary accent, menu headings'
    },
    {
      name: 'White',
      variable: '--white',
      value: '#ffffff',
      description: 'Pure white backgrounds'
    },
    {
      name: 'Gray 100',
      variable: '--gray-100',
      value: '#f8f9fa',
      description: 'Lightest gray'
    },
    {
      name: 'Gray 200',
      variable: '--gray-200',
      value: '#e9ecef',
      description: 'Light gray borders'
    },
    {
      name: 'Gray 300',
      variable: '--gray-300',
      value: '#dee2e6',
      description: 'Medium light gray'
    },
    {
      name: 'Gray 600',
      variable: '--gray-600',
      value: '#6c757d',
      description: 'Medium gray text'
    },
    {
      name: 'Gray 800',
      variable: '--gray-800',
      value: '#343a40',
      description: 'Dark gray elements'
    }
  ];

  return (
    <PageTemplate 
      title="Color Swatches" 
      subtitle="Design system colors used throughout the Belaire Mechanical website"
    >
      <section className="section">
        <div className="container">
          <div className="color-swatches-intro">
            <h2>Brand Color Palette</h2>
            <p>
              These are the primary colors that define the Belaire Mechanical brand identity 
              and ensure consistency across all website elements.
            </p>
          </div>
          
          <div className="color-grid">
            {colors.map((color, index) => (
              <div key={index} className="color-swatch">
                <div 
                  className="color-sample" 
                  style={{ backgroundColor: `var(${color.variable})` }}
                ></div>
                <div className="color-info">
                  <h3 className="color-name">{color.name}</h3>
                  <div className="color-details">
                    <span className="color-variable">{color.variable}</span>
                    <span className="color-value">{color.value}</span>
                  </div>
                  <p className="color-description">{color.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="usage-examples">
            <h2>Color Usage Examples</h2>
            <div className="usage-grid">
              <div className="usage-card">
                <h3 style={{ color: 'var(--accent-blue)' }}>Primary Actions</h3>
                <button className="btn-primary">Accent Blue Button</button>
                <p>Used for primary buttons, links, and call-to-action elements.</p>
              </div>
              
              <div className="usage-card">
                <h3 style={{ color: 'var(--accent2-red)' }}>Section Headers</h3>
                <div className="menu-section-title-demo">Menu Section Title</div>
                <p>Used for menu section titles and important headings.</p>
              </div>
              
              <div className="usage-card">
                <h3 style={{ color: 'var(--primary-black)' }}>Typography</h3>
                <p style={{ color: 'var(--gray-600)' }}>
                  Primary black for headings, gray-600 for body text.
                </p>
                <p>Ensures optimal readability and hierarchy.</p>
              </div>
              
              <div className="usage-card">
                <h3 style={{ color: 'var(--primary-black)' }}>Backgrounds</h3>
                <div className="bg-demo secondary-light">Secondary Light</div>
                <div className="bg-demo white">White</div>
                <p>Light backgrounds for sections and content areas.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageTemplate>
  );
};

export default ColorSwatches;
